import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'delete'

export default class OspreyContentBlocksTagsRemove extends BaseAction {
    constructor(dataKey) {
        const id = '57223bcd-6a08-44d1-a97f-c65b58037e2d'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeTagFromContentBlock(params) {
        const { contentBlockId, tagId } = params

        this.path = `/${resource}/${contentBlockId}/tags/${tagId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-tags-remove.js